import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LazyLeadershipCornerBanner = () =>
  import(/* webpackChunkName: "4-feat-leadership-corner-banner" */ './LeadershipCornerBanner');

const LoadableLeadershipCornerBanner: ComponentType = lazyLoadOnRender({ loader: LazyLeadershipCornerBanner });
export default LoadableLeadershipCornerBanner;
